"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = Popover;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const cn_1 = require("../lib/cn");
const overlay_1 = require("../lib/overlay");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 29 Oct 2026 · a panel of controls that hangs off the button that opened it. │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * `DropdownMenu` is a list of choices; this holds a form — pickers, a switch, rows — that somebody
 * works inside and leaves when done. The line item's *Szerkesztés* is the first; the mockup draws
 * none, so the menu's own surface (`bg-popover`, `shadow-pop`, 10px radius) is the specification.
 *
 * ⚠️ **On the overlay stack** (`useDismiss`): Escape closes the top layer only, so a picker open
 * inside it closes before the panel does, and a pick in that picker's portalled list is not an
 * outside click. Tab stays inside — it moves between the panel's controls.
 *
 * ⚠️ **Focus goes to the panel's first control when it opens, and back to the trigger when it
 * closes** — or a keyboard is left on a button behind a panel it cannot reach.
 */
function Popover({ open, onClose, label, content, children, width = 440, align = 'end', className, }) {
    const { surface, trigger } = (0, overlay_1.useDismiss)(open, onClose, { closeOnTab: false });
    const { rect } = (0, overlay_1.useAnchorRect)(open, trigger);
    const returnTo = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (!open)
            return;
        returnTo.current = document.activeElement;
        const frame = requestAnimationFrame(() => {
            (0, overlay_1.focusable)(surface.current)[0]?.focus();
        });
        return () => {
            cancelAnimationFrame(frame);
            const target = returnTo.current;
            if (target instanceof HTMLElement && document.contains(target))
                target.focus();
        };
    }, [open, surface]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { ref: trigger, className: "inline-flex", children: children }), open && rect !== null
                ? (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)("div", { ref: surface, role: "dialog", "aria-label": label, style: (0, overlay_1.anchorTo)(rect, { side: 'bottom', align, width }), className: (0, cn_1.cn)('pop-in bg-popover text-popover-foreground shadow-pop flex flex-col gap-4 overflow-y-auto rounded-[10px] border p-3.5', className), children: content }), document.body)
                : null] }));
}
//# sourceMappingURL=popover.js.map